import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
  padding-top: 0.4rem;
`;

export const IconCircle = styled.div<{ $background: string }>`
  width: 4rem;
  height: 4rem;
  border-radius: 999rem;
  background: ${({ $background }) => $background};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;
